import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import NavButton from '../homepage/header-banner/TopNavButton';
import Footer from '../homepage/footer/Footer';
import './assets/css/style-page-modal.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


import HeaderVn from "../detailpageVN/Page/component/headervn";
import FooterVn from "../detailpageVN/Page/component/footervn";

function ServerSignupVn() {
    const [isLoading, setIsLoading] = useState(true);
    // useEffect(() => {
    //     const handleMessage = (event) => {
    //         if (event.data.iframeHeight) {
    //             const iframe = document.getElementById('resizeIframeVn');
    //             if (iframe) {
    //                 iframe.style.height = event.data.iframeHeight + 'px';
    //             }
    //         }
    //     };

    //     window.addEventListener('message', handleMessage);
    //     return () => window.removeEventListener('message', handleMessage);
    // }, []);

    return (

        <div className="pageregistration">
            <HeaderVn />

            {isLoading && (
                <div style={{
                    padding: '40px',
                    fontSize: '18px',
                    color: '#555',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="spinner-border text-primary" role="status"></div>
                    <div>Đang tải nội dung, vui lòng đợi...</div>
                </div>
            )}

            {/* Modal */}
            <iframe
                id="resizeIframeVn"
                src="https://hanbiro.vn/pages/server-hosting-signup"
                style={{ width: '100%', border: 'none', height: '100vh' }}
                title="Cloud Service Signup"
                onLoad={() => setIsLoading(false)}
            />

            <FooterVn />
        </div>
    )
}

export default ServerSignupVn;